/**
 * Parse a DD/MM/YYYY string into a Date object.
 * Returns null if the string is empty or invalid.
 */
export function parseDateStr(str) {
  if (!str) return null;
  const parts = str.split("/");
  if (parts.length !== 3) return null;
  const [day, month, year] = parts.map(Number);
  if (!day || !month || !year) return null;
  const date = new Date(year, month - 1, day);
  return isNaN(date.getTime()) ? null : date;
}

/**
 * Format a Date object into DD/MM/YYYY string.
 */
export function formatDateStr(date) {
  if (!date) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Parse hour/minute strings into a Date object for the time picker.
 * Returns null if inputs are empty.
 */
export function parseTimeStr(hour, minute) {
  if (!hour && !minute) return null;
  const h = parseInt(hour, 10) || 0;
  const m = parseInt(minute, 10) || 0;
  const date = new Date();
  date.setHours(h, m, 0, 0);
  return date;
}

/**
 * Format a Date object into { hour, minute } strings (zero-padded).
 */
export function formatTimeStr(date) {
  if (!date) return { hour: "", minute: "" };
  return {
    hour: String(date.getHours()).padStart(2, "0"),
    minute: String(date.getMinutes()).padStart(2, "0"),
  };
}

export function formatEventTime(value) {
  if (!value) return "";
  const text = String(value).trim();
  if (!text) return "";
  if (/(AM|PM)$/i.test(text)) return text;

  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (!match) return text;

  const [, year, month, day, rawHour, minute] = match;
  const hour = Number(rawHour);
  const suffix = hour < 12 ? "AM" : "PM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${day}/${month}/${year} ${String(hour12).padStart(2, "0")}:${minute} ${suffix}`;
}

export function parseDisplayTimestamp(value) {
  if (!value) return null;
  const text = String(value).trim();

  const dayFirst = text.match(
    /^(\d{2})\/(\d{2})\/(\d{4})(?:[ ,]+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?)?$/i
  );
  if (dayFirst) {
    const [, day, month, year, rawHour, minute, second, meridiem] = dayFirst;
    let hour = Number(rawHour || 0);
    if (meridiem) {
      const upper = meridiem.toUpperCase();
      if (upper === "PM" && hour !== 12) hour += 12;
      if (upper === "AM" && hour === 12) hour = 0;
    }
    return new Date(
      Number(year), Number(month) - 1, Number(day),
      hour, Number(minute || 0), Number(second || 0)
    ).getTime();
  }

  const parsed = new Date(text).getTime();
  return Number.isNaN(parsed) ? null : parsed;
}
